<template>
  <div class="ebmss-shell">
    <div class="ebmss-steps">
      <div v-for="(step, i) in steps" :key="i" class="ebmss-step">
        <div class="ebmss-step__indicator">
          <div class="ebmss-step__num">{{ step.id }}</div>
          <div v-if="i < steps.length - 1" class="ebmss-step__line" />
        </div>
        <div class="ebmss-step__body">
          <div class="ebmss-step__title">{{ step.title }}</div>
          <ul class="ebmss-step__list">
            <li v-for="(item, j) in step.details" :key="j">
              <span v-html="item" />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="ebmss-footer">
      <vue-feather type="message-circle" size="14" class="ebmss-footer__icon" />
      Any questions? Contact us at
      <a href="mailto:info@hova.ai" class="ebmss-footer__link">info@hova.ai</a>
      or <span class="ebmss-footer__link">0793 090 500</span>.
    </div>
  </div>
</template>

<script>
export default {
  name: "EbmSettingsSteps",
  data() {
    return {
      steps: [
        {
          id: "01",
          title: "Gather Required Documents",
          details: [
            "RDB Certificate (Full registration) or TIN Certificate (For RRA & HOVA AI)",
            "Copy of National ID of the Business Owner (For RRA)",
            "Signed contract with HOVA AI. This will be sent to RRA by Hova AI.",
            "Signed commitment form with HOVA AI. This will be sent to RRA by Hova AI.",
          ],
        },
        {
          id: "02",
          title: "Send Your Request to RRA",
          details: [
            `Scan the QR code or use <a href="https://bit.ly/rraVsdcRequestGuide" target="_blank" class="ebmss-link">this link</a> for guidance on submitting your request.`,
            "After submitting, send us your <strong>tracking number</strong>, business name, and TIN to <a href='mailto:info@hova.ai' class='ebmss-link'>info@hova.ai</a> or 0793 090 500.",
          ],
        },
        {
          id: "03",
          title: "Receive Feedback From RRA",
          details: [
            "Once your request is approved, you will receive a message from RRA.",
            "If you've already been using another RRA EBM system, you must physically visit RRA to have it removed before you can start using HovaStore POS.",
          ],
        },
        {
          id: "04",
          title: "Install & Use HovaStore POS",
          details: [
            "Install the app from the Play Store/App Store. Search for 'HovaStore POS'.",
            "Sign up with your phone number and create or select your store.",
            "Tap your name at the bottom right, select RRA EBM Settings, and send a request to activate EBM.",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.ebmss-shell {
  background: color-mix(in srgb, var(--hs-surface) 92%, transparent);
  border: 1px solid var(--hs-border);
  border-radius: 18px;
  display: grid;
  gap: 1.5rem;
  padding: 1.5rem;
}

.ebmss-steps {
  display: grid;
  gap: 0;
}

.ebmss-step {
  display: flex;
  gap: 1rem;
}

.ebmss-step__indicator {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 0;
}

.ebmss-step__num {
  align-items: center;
  background: linear-gradient(135deg, var(--hs-primary), var(--hs-primary-strong, #2563eb));
  border-radius: 50%;
  box-shadow: 0 4px 12px color-mix(in srgb, var(--hs-primary) 28%, transparent);
  color: #fff;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 950;
  height: 2.1rem;
  justify-content: center;
  letter-spacing: 0.02em;
  width: 2.1rem;
}

.ebmss-step__line {
  background: color-mix(in srgb, var(--hs-border) 80%, transparent);
  flex: 1;
  margin: 0.35rem 0;
  min-height: 1.5rem;
  width: 2px;
}

.ebmss-step__body {
  display: grid;
  gap: 0.45rem;
  padding-bottom: 1.25rem;
}

.ebmss-step:last-child .ebmss-step__body {
  padding-bottom: 0;
}

.ebmss-step__title {
  color: var(--hs-text);
  font-size: 0.92rem;
  font-weight: 750;
  padding-top: 0.28rem;
}

.ebmss-step__list {
  color: var(--hs-muted);
  display: grid;
  font-size: 0.82rem;
  gap: 0.35rem;
  line-height: 1.55;
  list-style: disc;
  padding-left: 1.1rem;
}

.ebmss-footer {
  align-items: center;
  border-top: 1px solid var(--hs-border);
  color: var(--hs-muted);
  display: flex;
  flex-wrap: wrap;
  font-size: 0.8rem;
  gap: 0.35rem;
  padding-top: 1rem;
}

.ebmss-footer__icon {
  flex-shrink: 0;
}

.ebmss-footer__link {
  color: var(--hs-primary);
  font-weight: 650;
  text-decoration: none;
}

.ebmss-footer__link:hover {
  text-decoration: underline;
}

:deep(.ebmss-link) {
  color: var(--hs-primary);
  font-weight: 650;
  text-decoration: none;
}

:deep(.ebmss-link:hover) {
  text-decoration: underline;
}
</style>
